import { useQuery } from "@tanstack/react-query";
import { WeatherOverview } from "@bienesis/common";

import { useApi } from "../client";
import keys from "./keys";

/**
 * Overview météo d'une parcelle : prévision journalière (~7 jours) + horaire
 * du jour courant. Route backend : `GET /v1/weather-overview/:areaId`.
 */
export const useWeatherOverview = ({ areaId }: { areaId: string }) => {
  const api = useApi();

  return useQuery({
    queryKey: keys.overview(areaId),
    queryFn: async (): Promise<WeatherOverview> => {
      const response = await api.get(`weather-overview/${areaId}`);
      return response.json();
    },
    retry: 0,
  });
};
